/** @jsx jsx */
import React, { useEffect, useState } from 'react';
import { jsx, Box, Container, Flex, Text } from 'theme-ui';
import { Navigation} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { GatsbyImage } from 'gatsby-plugin-image';
import ContentfulRichText from '../../shared/ContentfulRichText';
import Icon from "../../shared/Icon";

const TestimonialCarousal = ({ carousalData }) => {
    const [swiper, setSwiper] = React.useState();
    const prevRef = React.useRef();
    const nextRef = React.useRef();
    React.useEffect(() => {
        if (swiper) {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
        }
    }, [swiper]);
    const [domLoaded, setDomLoaded] = useState(false);
    useEffect(() => {
      setDomLoaded(true);
    }, []);
    return (
        <Container sx={{ textAlign: 'center' }}>
            <Flex className="carousel-container">
                <div className="swiper-button" ref={prevRef}>
                    <Icon icon='md-arrow-left' />
                </div>
                <Box sx={{ color: '#FF6310', left: ['10px', null, '40px', '120px'] }} className="carousel_quote">
                    <Icon icon='ri-double-quotes-l' iconSize={80} />
                </Box>
                {domLoaded && (
                <Swiper className="mySwiper" modules={[Navigation]} spaceBetween={24}
                    slidesPerView={1}
                    loop={true}
                    navigation={{
                        prevEl: prevRef?.current,
                        nextEl: nextRef?.current
                    }}
                    updateOnWindowResize
                    observer
                    observeParents
                    initialSlide={2}
                    onSwiper={setSwiper}>

                    <Flex key={carousalData.id} sx={{ justifyContent: 'center', alignItems: 'center', padding: ['30px', '120px'] }}>
                        {carousalData.map((data) => (

                            <SwiperSlide style={{ backgroundColor: '#fff', width: '90%' }}>
                                <Box sx={{ padding: ['30px 30px 0 30px', '70px 70px 0 70px'], textAlign: "center", lineHeight:1.5 }}>
                                    <ContentfulRichText richText={data?.description} textfontSize="24px" />
                                </Box>

                                <Flex sx={{ flexDirection:['column-reverse', 'row'], justifyContent: 'center', alignItems: 'center' }} className="testimonial-logo-div">
                                    <Box sx={{ width: ['200px', '150px'], padding:['20px 0', '0'] }} className="testimonial-logo">
                                        <GatsbyImage
                                            image={data.companyLogo?.gatsbyImageData}
                                            alt={data.companyLogoAltText}
                                        />
                                    </Box>
                                    <Flex p={3} >
                                        <Box sx={{ width: '150px' }}>
                                            <GatsbyImage
                                                image={data.clientImage?.gatsbyImageData}
                                                alt={data.clientImageAltText}
                                            />
                                        </Box>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems:['center', 'flex-start'], justifyContent: 'center' }} className="testimonial-client-details">
                                            <Text sx={{ fontSize: '18px', fontWeight: 600 }}>{data.clientName}</Text>
                                            <Text sx={{ fontSize: '14px' }}>{data.clientDesignation}</Text>
                                        </Box>
                                    </Flex>
                                </Flex>


                            </SwiperSlide>
                        ))}
                    </Flex>
                </Swiper>
                )}
                <div className="swiper-button" ref={nextRef}>
                    <Icon icon='md-arrow-right' />
                </div>
            </Flex>
        </Container>
    );
};

export default TestimonialCarousal;
